import * as React from 'react';

import { CellControllerKind } from 'entities/TableControllers';

import { InputDateController } from './InputDateController';
import { InputNumberController } from './InputNumberController';
import { InputStringController } from './InputStringController';
import { NavigationController } from './NavigationController';
import { NumberController } from './NumberController';
import { ProgressBarController } from './ProgressBarController';
import { SelectController } from './SelectController';
import { SwitchController } from './SwitchController';
import { TextController } from './TextController';
import { TableControllerProps } from './types';

export const CONTROLLER_COMPONENTS: Record<
  CellControllerKind,
  React.ComponentType<TableControllerProps>
> = {
  [CellControllerKind.TEXT]: TextController,
  [CellControllerKind.SELECT]: SelectController,
  [CellControllerKind.INPUT_STRING]: InputStringController,
  [CellControllerKind.INPUT_DATE]: InputDateController,
  [CellControllerKind.SWITCH]: SwitchController,
  [CellControllerKind.PROGRESS_BAR]: ProgressBarController,
  [CellControllerKind.NAVIGATION]: NavigationController,
  [CellControllerKind.NUMBER]: NumberController,
  [CellControllerKind.INPUT_NUMBER]: InputNumberController,
};
